import React, { useRef, useEffect } from 'react';
import * as THREE from 'three';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';

const ModelViewer: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const touch = useRef({
    startX: 0,
    startY: 0,
    isDragging: false,
  });

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.z = 5;
    camera.position.y = 0.9;

    const renderer = new THREE.WebGLRenderer();
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    container.appendChild(renderer.domElement);
    renderer.setClearColor(new THREE.Color(200 / 255, 255 / 255, 255 / 255), 0);

    const loader = new FBXLoader();
    loader.load('/3dmodels/source/shinchan_04.fbx', (fbx) => {
      const textureLoader = new THREE.TextureLoader();
      const baseColorTexture = textureLoader.load('/3dmodels/textures/shinchan_04_UV1_BaseColor.png');
      const grassBaseColorTexture = textureLoader.load('/3dmodels/textures/shinchan_04_Grass_BaseColor.png');
      const grayScaleTexture = textureLoader.load('/3dmodels/textures/Grayscale.png');

      const baseColorMaterial = new THREE.MeshBasicMaterial({ map: baseColorTexture, side: THREE.DoubleSide });
      const grassBaseColorMaterial = new THREE.MeshBasicMaterial({ map: grassBaseColorTexture });
      const grayScaleMaterial = new THREE.MeshBasicMaterial({ map: grayScaleTexture });

      fbx.traverse((child) => {
        if (child instanceof THREE.Mesh) {
          if (child.name === 'Grasss') {
            child.material = grassBaseColorMaterial;
          } else if (
            child.name === 'shinchan_shinchan1' ||
            child.name === 'shinchan_shinchan2' ||
            child.name === 'polySurface62' ||
            child.name === 'polySurface61' ||
            child.name === 'polySurface60' ||
            child.name === 'polySurface59' ||
            child.name === 'polySurface58' ||
            child.name === 'polySurface57' ||
            child.name === 'polySurface56' ||
            child.name === 'polySurface54' ||
            child.name === 'polySurface63' ||
            child.name === 'polySurface64'
          ) {
            child.material = baseColorMaterial;
          } else if (child.name === 'outlinner3') {
            child.material = grayScaleMaterial;
          }
        }
      });

      const model = fbx;
      scene.add(model);

      const lightColor = new THREE.Color(0xffffff00);
      const ambientLight = new THREE.AmbientLight(lightColor, 0.5);
      scene.add(ambientLight);

      const directionalLight = new THREE.DirectionalLight(lightColor, 1);
      directionalLight.position.set(1, 1, 1);
      scene.add(directionalLight);

 const handleTouchStart = (event: TouchEvent) => {
  touch.current.startX = event.touches[0].clientX;
  touch.current.startY = event.touches[0].clientY;
  touch.current.isDragging = true;
};

const handleTouchMove = (event: TouchEvent) => {
  if (!touch.current.isDragging) return;

  const deltaX = event.touches[0].clientX - touch.current.startX;
  model.rotation.y += deltaX * 0.01;
  touch.current.startX = event.touches[0].clientX;
};
const handleTouchEnd = () => {
  touch.current.isDragging = false;
};
const handleMouseDown = (event: MouseEvent) => {
  touch.current.startX = event.clientX;
  touch.current.isDragging = true;
};

const handleMouseMove = (event: MouseEvent) => {
  if (!touch.current.isDragging) return;

  const deltaX = event.clientX - touch.current.startX;
  model.rotation.y += deltaX * 0.01;
  touch.current.startX = event.clientX;
};

const handleMouseUp = () => {
  touch.current.isDragging = false;
};
container.addEventListener('touchstart', handleTouchStart);
container.addEventListener('touchmove', handleTouchMove);
container.addEventListener('touchend', handleTouchEnd);
container.addEventListener('mousedown', handleMouseDown);
container.addEventListener('mousemove', handleMouseMove);
container.addEventListener('mouseup', handleMouseUp);

const animate = () => {
  renderer.render(scene, camera);
  requestAnimationFrame(animate);
};
animate();

 return () => {
      container.removeEventListener('touchstart', handleTouchStart);
      container.removeEventListener('touchmove', handleTouchMove);
      container.removeEventListener('touchend', handleTouchEnd);
      container.removeEventListener('mousedown', handleMouseDown);
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseup', handleMouseUp);
      container.removeChild(renderer.domElement);
    };
  });
  }, []);

  return <div ref={containerRef} className='w-screen h-screen ' />;
};

export default ModelViewer;
